import { createFileRoute } from '@tanstack/react-router'
import { EventCard, mapFounderFeedItems } from '@workspace/seedforge-ui/feed'
import { Loader2, Mic } from 'lucide-react'
import { FounderLayout } from '../../../../components/founder-layout'
import { useFeedQuery } from '../../../../hooks/api'
import { useBasePath } from '../../../../hooks/use-base-path'

export const Route = createFileRoute('/app/startup/$id/feed')({
  component: FeedPage,
})

function FeedPage() {
  const { id: startupId } = Route.useParams()
  const basePath = useBasePath()
  const { data, isLoading, error } = useFeedQuery(startupId)

  if (isLoading) {
    return (
      <FounderLayout activeNav="">
        <div className="flex h-64 items-center justify-center">
          <Loader2 className="size-6 animate-spin text-muted-foreground" />
        </div>
      </FounderLayout>
    )
  }

  if (error || !data?.data) {
    return (
      <FounderLayout activeNav="">
        <div className="flex h-64 items-center justify-center text-muted-foreground">
          Failed to load feed
        </div>
      </FounderLayout>
    )
  }

  const timeline = mapFounderFeedItems(data.data, basePath)

  return (
    <FounderLayout activeNav="">
      {timeline.length === 0 ? (
        <div className="flex min-h-[calc(100vh-6rem)] flex-col items-center justify-center text-center">
          <div className="flex size-16 items-center justify-center rounded-2xl bg-muted/50">
            <Mic className="size-7 text-muted-foreground/40" />
          </div>
          <h2 className="mt-5 text-lg font-semibold text-foreground">No activity yet</h2>
          <p className="mt-1.5 max-w-xs text-sm text-muted-foreground/60">
            Submit your first pitch to start building your feed
          </p>
        </div>
      ) : (
        <div className="mx-auto max-w-6xl py-2">
          <div>
            <h1 className="text-2xl font-semibold tracking-tight text-foreground">Feed</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Everything that shaped your startup score
            </p>
          </div>
          <div className="mt-8">
            {timeline.map((event) => (
              <EventCard key={event.id} event={event} />
            ))}
          </div>
        </div>
      )}
    </FounderLayout>
  )
}
